import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class TopPicksFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: "Top Picks",
      name: "topPicks",
      value,
    });
  }
}

export default TopPicksFilter;
export { TopPicksFilter };
